const ActionButton = ({ active, icon, onClick }) => {
  const baseStyle = {
    height: "40px",
    width: "40px",
    borderRadius: "40px",
  };

  const activeStyle = {
    ...baseStyle,
    border: "1px solid red",
  };

  return (
    <button
      className="btn bg-danger-subtle text-danger"
      style={active ? activeStyle : baseStyle}
      onClick={onClick}
    >
      <i className={`bi ${icon}`}></i>
    </button>
  );
};

export default ActionButton;
